import { Entity } from '@core/entities/entity'
import { plainToInstance, Type } from 'class-transformer'
import { LinkedProcessItemTypes } from '@core/entities/linkedProcesses/types'
import {
  LinkedPermitResult,
  LinkedChecklistResult,
  ILinkedProcessItemResult,
  LinkedObservationResult,
  LinkedPeriodicChecksResult,
  LinkedTaskResult,
  LinkedRegisterItemResult,
} from '@core/entities/linkedProcesses'
import { TemplateQuestionGroup } from '@core/entities/template/TemplateQuestionGroup'

export class LinkedProcessItemResult extends Entity<ILinkedProcessItemResult> {
  createdOn: string

  type: LinkedProcessItemTypes

  @Type(() => LinkedObservationResult)
  linkedObservationResult?: LinkedObservationResult

  @Type(() => LinkedChecklistResult)
  linkedChecklistResult?: LinkedChecklistResult

  @Type(() => LinkedChecklistResult)
  linkedInspectionResult?: LinkedChecklistResult

  @Type(() => LinkedPermitResult)
  linkedPermitResult?: LinkedPermitResult

  @Type(() => LinkedTaskResult)
  linkedTaskResult?: LinkedTaskResult

  @Type(() => LinkedPeriodicChecksResult)
  linkedPeriodicChecksResult?: LinkedPeriodicChecksResult

  @Type(() => LinkedRegisterItemResult)
  linkedRegisterItemResult?: LinkedRegisterItemResult

  @Type(() => TemplateQuestionGroup)
  answer?: TemplateQuestionGroup

  public getPreviewPropertyIds(): Array<string> {
    if (this.answer) {
      return this.answer.data[0]?.previewPropertyIds || []
    }
    return []
  }

  public static new(payload: unknown): LinkedProcessItemResult {
    const entity = plainToInstance(LinkedProcessItemResult, payload)

    return entity
  }
}
